// Global CSS imports
import 'bootstrap/dist/css/bootstrap.min.css'
import 'primeflex/primeflex.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import './assets/main.css'
import { createHead } from '@unhead/vue/client'

import axiosInstance from './plugins/axios'

import { createPinia } from 'pinia'

//import { useStyleStore } from './store/styleStore'
//import { useFlagStore } from './store/flagStore'

import { createApp } from 'vue'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'

import 'bootstrap'

import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'

import App from './App.vue'
import initializeRouter from './router'

const bootstrap = async () => {
  if (process.env.NODE_ENV === 'production') {
    console.log = function () {}
    console.info = function () {}
    console.debug = function () {}
    console.warn = function () {}
    console.error = function () {}
  }

  const app = createApp(App)

  const head = createHead()
  app.use(head)

  const pinia = createPinia()

  app.use(pinia)

  app.use(PrimeVue, {
    ripple: true,
    theme: {
      preset: Aura,
      options: {
        prefix: 'p',
        darkModeSelector: '.airin-dark',
        cssLayer: false
      }
    }
  })

  app.use(ToastService)
  app.directive('tooltip', Tooltip)

  app.config.globalProperties.$axios = axiosInstance

  const router = await initializeRouter()
  app.use(router)

  //const styleStore = useStyleStore();
  //const flagStore = useFlagStore();

  try {
    //await styleStore.loadStyles()
  } catch (error) {
    console.error('Error loading styles:', error)
  }

  app.mount('#app')
}

bootstrap().catch((error) => {
  console.error('Error during app initialization:', error)
})
